(() => {
  const qs = (s, el = document) => el.querySelector(s);
  const qsa = (s, el = document) => [...el.querySelectorAll(s)];

  const header = qs('[data-sticky-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-compact', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    const menuToggle = qs('[data-header-menu-toggle]', header);
    if (menuToggle) {
      const megaShell = qs('.mega-shell', header);
      const headerLeft = qs('.header__left', header);
      let megaHoverTimer;
      const showMegaHover = () => {
        clearTimeout(megaHoverTimer);
        if (!header.classList.contains('is-mega-click-closed')) header.classList.add('is-mega-hover');
      };
      const hideMegaHover = () => {
        clearTimeout(megaHoverTimer);
        megaHoverTimer = setTimeout(() => header.classList.remove('is-mega-hover'), 180);
      };
      [headerLeft, megaShell].forEach((area) => {
        if (!area) return;
        area.addEventListener('mouseenter', showMegaHover);
        area.addEventListener('mouseleave', hideMegaHover);
      });
      menuToggle.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 760px)').matches) {
          openMobile();
          return;
        }
        const wasOpen = header.classList.contains('is-mega-open');
        header.classList.toggle('is-mega-click-closed', wasOpen);
        if (wasOpen) header.classList.remove('is-mega-hover');
        header.classList.toggle('is-mega-open', !wasOpen);
        const isOpen = !wasOpen;
        menuToggle.setAttribute('aria-expanded', String(isOpen));
      });
      header.addEventListener('mouseleave', () => header.classList.remove('is-mega-click-closed'));
      document.addEventListener('click', (event) => {
        if (!header.classList.contains('is-mega-open')) return;
        if (header.contains(event.target)) return;
        header.classList.remove('is-mega-open');
        header.classList.remove('is-mega-hover');
        menuToggle.setAttribute('aria-expanded', 'false');
      });
    }
  }

  const backToTop = qs('[data-back-to-top]');
  if (backToTop) {
    const toggleBackToTop = () => backToTop.classList.toggle('is-visible', window.scrollY > 520);
    toggleBackToTop();
    window.addEventListener('scroll', toggleBackToTop, { passive: true });
    backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  qsa('[data-mega-tab]').forEach((tab) => {
    tab.addEventListener('mouseenter', () => {
      const index = tab.dataset.megaTab;
      qsa('[data-mega-tab]').forEach((item) => item.classList.toggle('is-active', item === tab));
      qsa('[data-mega-content]').forEach((panel) => panel.classList.toggle('is-active', panel.dataset.megaContent === index));
    });
  });

  qsa('[data-hero-slider]').forEach((slider) => {
    const slides = qsa('.hero-slide', slider);
    const dots = qsa('[data-hero-dots] button', slider);
    if (slides.length < 2) return;
    let active = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let autoTimer;
    const show = (next) => {
      active = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
    };
    const startAuto = () => {
      window.clearInterval(autoTimer);
      autoTimer = window.setInterval(() => show(active + 1), 5200);
    };
    const go = (next) => {
      show(next);
      startAuto();
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    qs('[data-hero-prev]', slider)?.addEventListener('click', () => go(active - 1));
    qs('[data-hero-next]', slider)?.addEventListener('click', () => go(active + 1));
    slider.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });
    slider.addEventListener('touchend', (event) => {
      const diffX = event.changedTouches[0].clientX - touchStartX;
      const diffY = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(diffX) < 48 || Math.abs(diffX) < Math.abs(diffY) * 1.25) return;
      go(diffX < 0 ? active + 1 : active - 1);
    }, { passive: true });
    startAuto();
  });

  qsa('[data-price-range]').forEach((range) => {
    const minRange = qs('[data-price-min-range]', range);
    const maxRange = qs('[data-price-max-range]', range);
    const minInput = qs('[data-price-min-input]', range);
    const maxInput = qs('[data-price-max-input]', range);
    const minLabel = qs('[data-price-min-label]', range);
    const maxLabel = qs('[data-price-max-label]', range);
    if (!minRange || !maxRange || !minInput || !maxInput) return;
    const format = (value) => `${Number(value).toLocaleString('sr-RS')} RSD`;
    const sync = (source) => {
      let min = Number(minRange.value);
      let max = Number(maxRange.value);
      if (min > max) {
        if (source === 'min') max = min;
        else min = max;
      }
      minRange.value = min;
      maxRange.value = max;
      minInput.value = min;
      maxInput.value = max;
      if (minLabel) minLabel.textContent = format(min);
      if (maxLabel) maxLabel.textContent = format(max);
    };
    minRange.addEventListener('input', () => sync('min'));
    maxRange.addEventListener('input', () => sync('max'));
    minInput.addEventListener('input', () => {
      minRange.value = minInput.value;
      sync('min');
    });
    maxInput.addEventListener('input', () => {
      maxRange.value = maxInput.value;
      sync('max');
    });
    sync();
  });

  const mobileMenu = qs('[data-mobile-menu]');
  const openMobile = () => {
    if (!mobileMenu) return;
    mobileMenu.hidden = false;
    document.body.style.overflow = 'hidden';
  };
  const closeMobile = () => {
    if (!mobileMenu) return;
    mobileMenu.hidden = true;
    document.body.style.overflow = '';
  };
  qsa('[data-mobile-menu-open]').forEach((btn) => btn.addEventListener('click', openMobile));
  qsa('[data-mobile-menu-close]').forEach((btn) => btn.addEventListener('click', closeMobile));

  const mobileSearch = qs('[data-mobile-search]');
  const openMobileSearch = () => {
    if (!mobileSearch) return;
    mobileSearch.hidden = false;
    document.body.style.overflow = 'hidden';
    window.setTimeout(() => qs('[data-mobile-search-input]', mobileSearch)?.focus(), 60);
  };
  const closeMobileSearch = () => {
    if (!mobileSearch) return;
    mobileSearch.hidden = true;
    document.body.style.overflow = '';
  };
  qsa('[data-mobile-search-open]').forEach((btn) => btn.addEventListener('click', openMobileSearch));
  qsa('[data-mobile-search-close]').forEach((btn) => btn.addEventListener('click', closeMobileSearch));
  const drawer = qs('[data-cart-drawer]');
  const isMobileCartFlow = () => window.matchMedia('(max-width: 760px)').matches;
  const openCart = () => drawer && drawer.setAttribute('aria-hidden', 'false');
  const closeCart = () => drawer && drawer.setAttribute('aria-hidden', 'true');
  const showCartToast = () => {
    const toast = qs('[data-cart-toast]');
    if (!toast) return;
    toast.classList.remove('is-visible');
    window.requestAnimationFrame(() => {
      toast.classList.add('is-visible');
      window.setTimeout(() => toast.classList.remove('is-visible'), 2200);
    });
  };
  qsa('[data-cart-open]').forEach((btn) => btn.addEventListener('click', openCart));
  qsa('[data-cart-close]').forEach((btn) => btn.addEventListener('click', closeCart));

  const refreshCart = async () => {
    const cart = await fetch('/cart.js').then((r) => r.json());
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
    qsa('[data-cart-total]').forEach((total) => {
      total.textContent = window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(cart.total_price) : `${(cart.total_price / 100).toFixed(2)}`;
    });
    const html = await fetch('/?sections=cart-drawer').then((r) => r.json());
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html['cart-drawer'] || '';
    const freshItems = qs('[data-cart-items]', wrapper);
    const currentItems = qsa('[data-cart-items]');
    if (freshItems && currentItems.length) currentItems.forEach((items) => (items.innerHTML = freshItems.innerHTML));
  };

  const checkoutUrl = () => {
    const locale = document.documentElement.lang;
    return locale ? `/checkout?locale=${encodeURIComponent(locale)}` : '/checkout';
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-buy-now-form]');
    if (!form) return;
    event.preventDefault();
    const button = qs('[type="submit"]', form);
    if (form.dataset.available === 'false' || button?.disabled) return;
    if (button) button.disabled = true;
    try {
      await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      window.location.href = checkoutUrl();
    } catch (error) {
      if (button) button.disabled = false;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = qs('[type="submit"]', form);
    if (form.dataset.available === 'false' || button?.disabled) return;
    if (button) button.disabled = true;
    try {
      const cushionChoice = qs('[data-cushion-upsell] input[name="cushion_choice"]:checked', form);
      if (cushionChoice && cushionChoice.value) {
        const productId = qs('input[name="id"]', form)?.value;
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(productId), quantity: 1 },
              { id: Number(cushionChoice.value), quantity: 1 }
            ]
          })
        });
      } else {
        const formData = new FormData(form);
        formData.delete('cushion_choice');
        qsa('[data-cushion-variant]', form).forEach((input) => formData.delete(input.name));
        await fetch('/cart/add.js', { method: 'POST', body: formData });
      }
      await refreshCart();
      showCartToast();
      if (!isMobileCartFlow()) openCart();
    } finally {
      if (button && form.dataset.available !== 'false') button.disabled = false;
    }
  });

  document.addEventListener('click', async (event) => {
    const remove = event.target.closest('[data-cart-remove]');
    const quantity = event.target.closest('[data-cart-quantity]');
    if (!remove && !quantity) return;
    const key = remove ? remove.dataset.cartRemove : quantity.dataset.cartQuantity;
    const nextQuantity = remove ? 0 : Number(quantity.dataset.cartQuantityValue);
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, nextQuantity) })
    });
    await refreshCart();
  });

  qsa('[data-product-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const img = qs('.product-media__main img');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = thumb.dataset.productThumb;
      }
      qsa('[data-product-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
    });
  });

  const variantData = qs('[data-product-json]');
  const productForm = qs('.product-page [data-product-form]');
  if (variantData && productForm) {
    const variants = JSON.parse(variantData.textContent);
    const idInput = qs('input[name="id"]', productForm);
    const stockPill = qs('[data-stock-pill]');
    const submitButton = qs('.product-actions [type="submit"]', productForm);
    const stickyButton = qs('[data-sticky-add-button]');
    const currentPrice = qs('[data-product-current-price]');
    const stickyPrice = qs('[data-product-sticky-price]');
    const paymentWrapper = qs('[data-payment-wrapper]', productForm);
    const selectedCushion = () => qs('[data-cushion-upsell] input[name="cushion_choice"]:checked', productForm);
    const syncCushionUpsell = () => {
      qsa('[data-cushion-product]', productForm).forEach((item) => {
        const choice = qs('[data-cushion-choice]', item);
        const variants = qs('[data-cushion-variants]', item);
        const selectedVariant = qs('[data-cushion-variant]:checked', item);
        const price = qs('[data-cushion-price]', item);
        const isSelected = Boolean(choice?.checked);
        if (variants) variants.hidden = !isSelected;
        if (choice && selectedVariant) choice.value = selectedVariant.value;
        if (price && selectedVariant?.dataset.price) price.textContent = selectedVariant.dataset.price;
      });
    };
    const updatePaymentVisibility = (variantAvailable) => {
      if (paymentWrapper) paymentWrapper.hidden = !variantAvailable || Boolean(selectedCushion()?.value);
    };
    const formatMoney = (value) => {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(value);
      return `${(value / 100).toLocaleString('sr-RS')} RSD`;
    };
    const selectedOptions = () => qsa('.variant-picker', productForm).map((picker) => {
      const checked = qs('input:checked', picker);
      return checked && checked.value;
    });
    const updateOptionAvailability = () => {
      const selected = selectedOptions();
      qsa('.variant-picker', productForm).forEach((picker) => {
        const optionIndex = Number(picker.dataset.optionIndex);
        qsa('label', picker).forEach((label) => {
          const value = label.dataset.optionValue;
          const possible = variants.some((variant) => {
            if (!variant.available || variant.options[optionIndex] !== value) return false;
            return variant.options.every((optionValue, index) => index === optionIndex || !selected[index] || selected[index] === optionValue);
          });
          label.classList.toggle('is-unavailable', !possible);
          const input = qs('input', label);
          if (input) input.setAttribute('aria-disabled', String(!possible));
        });
      });
    };
    const updateVariant = () => {
      const selected = selectedOptions();
      const match = variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
      if (!match) return;
      if (idInput) idInput.value = match.id;
      productForm.dataset.available = String(match.available);
      if (currentPrice) currentPrice.textContent = formatMoney(match.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);
      if (stockPill) {
        stockPill.classList.toggle('is-available', match.available);
        stockPill.classList.toggle('is-unavailable', !match.available);
        const label = qs('strong', stockPill);
        if (label) label.textContent = match.available ? 'Na stanju' : 'Nema na stanju';
      }
      if (submitButton) {
        submitButton.disabled = !match.available;
        submitButton.setAttribute('aria-disabled', String(!match.available));
        submitButton.textContent = match.available ? 'Dodaj u korpu' : 'Nema na stanju';
      }
      if (stickyButton) {
        stickyButton.disabled = !match.available;
        stickyButton.setAttribute('aria-disabled', String(!match.available));
        stickyButton.textContent = match.available ? 'Dodaj u korpu' : 'Nema na stanju';
      }
      updatePaymentVisibility(match.available);
      if (match.featured_image && match.featured_image.src) {
        const img = qs('.product-media__main img');
        if (img) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = match.featured_image.src;
        }
      }
      updateOptionAvailability();
    };
    qsa('.variant-picker input', productForm).forEach((input) => input.addEventListener('change', updateVariant));
    qsa('[data-cushion-upsell] input[name="cushion_choice"]', productForm).forEach((input) => {
      input.addEventListener('change', () => {
        syncCushionUpsell();
        updatePaymentVisibility(productForm.dataset.available !== 'false');
      });
    });
    qsa('[data-cushion-variant]', productForm).forEach((input) => {
      input.addEventListener('change', () => {
        const item = input.closest('[data-cushion-product]');
        const choice = qs('[data-cushion-choice]', item);
        if (choice && !choice.checked && !choice.disabled) {
          choice.checked = true;
          choice.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        syncCushionUpsell();
        updatePaymentVisibility(productForm.dataset.available !== 'false');
      });
    });
    syncCushionUpsell();
    updatePaymentVisibility(productForm.dataset.available !== 'false');
    updateOptionAvailability();
  }

  const stickyCta = qs('[data-product-sticky-cta]');
  const primaryActions = qs('[data-primary-product-actions]');
  if (stickyCta && primaryActions) {
    const footer = qs('.site-footer');
    const toggleStickyCta = () => {
      if (!window.matchMedia('(max-width: 760px)').matches) {
        stickyCta.hidden = true;
        stickyCta.classList.remove('is-visible');
        return;
      }
      const actionBottom = primaryActions.getBoundingClientRect().bottom;
      const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      const shouldShow = actionBottom < 18 && footerTop > window.innerHeight + 24;
      stickyCta.hidden = !shouldShow;
      stickyCta.classList.toggle('is-visible', shouldShow);
    };
    toggleStickyCta();
    window.addEventListener('scroll', toggleStickyCta, { passive: true });
    window.addEventListener('resize', toggleStickyCta);
  }
})();
